<div class="modal-header d-flex justify-content-between">
  <h1 class="modal-title" tabindex="-1">Send Welcome Email</h1>
  <span (click)="cancel()" role="button" class="ms-auto">
    <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
  </span>
</div>

<div class="modal-body">
  @if (loading()) {
    <div class="d-flex justify-content-center py-5">
      <div class="spinner-border text-primary" role="status"></div>
    </div>
  } @else if (loadError()) {
    <div class="alert alert-danger mb-0">{{ loadError() }}</div>
  } @else if (preview(); as letter) {
    <div class="small mb-3">
      <div>
        <span class="text-muted">To:</span>
        @if (letter.to; as to) {
          {{ to.name }} &lt;{{ to.email }}&gt; <span class="text-muted">({{ to.role }})</span>
        }
      </div>
      <div>
        <span class="text-muted">CC:</span>
        @for (copy of letter.cc; track copy.email) {
          <span class="copy-recipient">
            {{ copy.name }} &lt;{{ copy.email }}&gt; <span class="text-muted">({{ copy.role }})</span>
          </span>
        } @empty {
          <span class="text-muted">No one</span>
        }
      </div>
      <div><span class="text-muted">Subject:</span> {{ letter.subject }}</div>
    </div>

    <div class="welcome-email-preview border rounded-3 mb-3">
      <iframe
        [src]="previewUrl()"
        class="w-100 h-100 border-0"
        sandbox="allow-same-origin"
        title="Welcome email preview"
      ></iframe>
    </div>

    <h2 class="fs-16 fw-500 mb-2">Attachments</h2>
    @for (name of letter.projectDocuments; track name) {
      <div class="d-flex align-items-center gap-2 mb-1">
        <i class="bi bi-paperclip"></i>
        <span>{{ name }}</span>
        <span class="text-muted small">Included for every lot in this project</span>
      </div>
    }

    <div class="form-check my-2">
      <input
        class="form-check-input"
        type="checkbox"
        id="attachAps"
        [checked]="attachAps()"
        [disabled]="!apsAvailable()"
        (change)="toggleAttachAps($event)"
      />
      <label class="form-check-label" for="attachAps">
        Attach APS
        @if (apsAvailable()) {
          <span class="text-muted">({{ letter.aps.fileName }})</span>
        }
      </label>
      @if (!apsAvailable()) {
        <div class="text-muted small">{{ letter.aps.reason }}</div>
      }
    </div>

    <file-drop
      [fileAcceptedFormat]="acceptedFormats"
      titleMsg="Add documents"
      buttonText="Drag and drop or click to"
      (onFileDrop)="onFilesDropped($event)"
    />
    @if (fileError()) {
      <div class="text-danger small mt-1">{{ fileError() }}</div>
    }

    <div class="d-flex flex-wrap gap-2 mt-2">
      @for (upload of uploads(); track upload.key) {
        <span class="upload-chip" [class.upload-chip-failed]="upload.status === 'failed'">
          @if (upload.status === 'uploading') {
            <span class="spinner-border spinner-border-sm" role="status"></span>
          }
          {{ upload.file.name }} · {{ formatSize(upload.file.size) }}
          @if (upload.status === 'failed') {
            <span>Upload failed</span>
            <a role="button" class="text-decoration-underline" (click)="startUpload(upload.key)">Retry</a>
          }
          <a role="button" aria-label="Remove" (click)="removeUpload(upload.key)">&times;</a>
        </span>
      }
    </div>
  }
</div>

<div class="modal-footer">
  <span class="text-muted small me-auto">Sending can't be undone.</span>
  <button type="button" class="btn btn-secondary btn-h45" (click)="cancel()">Cancel</button>
  <button type="button" class="btn btn-primary btn-h45" [disabled]="!canSend()" (click)="send()">
    @if (sending()) {
      <span class="spinner-border spinner-border-sm me-2" role="status"></span>
    }
    Send
  </button>
</div>
